<template>
  <el-dialog class="dialog-edit-role" :title="title" :visible.sync="visible" width="500px">
    <ConfigForms ref="form" labelWidth="140px" contentWidth="220px" :formItems="formItems" :data="formData" inline />
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms';
import { appOptions } from '../../../config';
// import { roleTagTypes } from '../../config';
// { name: 'App', key: 'appId' },
//   { name: '产品域名', key: 'url' },
//   { name: '单次聊天积分', key: 'balance' },
//   {
//     name: '状态', key: 'status', component: Switch, props(value) {
//       return { value, disabled: true }
//     }
//   },
// PromptIntegral     int                json:"promptIntegral" bson:"promptIntegral"         // 提示词每百万价格
// CompletionInterval int                json:"completionInterval" bson:"completionInterval" // 完成词每百万价格
const formItems = [
  { type: 'select', label: 'App', required: true, key: 'appId', options: appOptions }, // App
  { type: 'text', label: '产品域名', required: true, key: 'appUrl' },
  { type: 'number', label: '价格倍率', required: true, key: 'priceMultiple' },
  // { type: 'number', label: '提示词每百万价格', required: true, key: 'promptIntegral' },
  // { type: 'number', label: '完成词每百万价格', required: true, key: 'completionInterval' },
  { type: 'switch', label: '状态', required: true, key: 'status' },
]
export default {
  name: 'EditProductConfig',
  emit: ['close'],
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formItems,
      formData: null,
    };
  },
  watch: {
  },
  computed: {
    isEdit() {
      return !!this.formData
    },
    title() {
      return this.isEdit ? '编辑产品配置' : '新增产品配置'
    }
  },
  created() {

  },
  methods: {
    close() {
      this.visible = false
    },
    open(row) {
      this.formData = null
      if (row) {
        // TODO：参数待完善
        this.formData = { ...row }
      }
      this.visible = true
    },
    async sure() {
      try {
        const form = await this.$refs.form.validate();
        const data = { ...form }
        this.$emit('sure', { isEdit: this.isEdit, data })
      } catch (error) {
        console.error('sure error:', error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-role {
  /deep/ .el-date-editor.el-input {
    width: 200px;

  }
}
</style>
